module.exports = __webpack_public_path__ + "img/x6.777b46cf.jpg";